// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2f0Gk","left":"InfoRow_left__3bUm5"};